import { RedirectionLinks } from "./RedirectionLinks";

const { PRIVACY_POLICY_LINK, TERMS_OF_USE_LINK} = RedirectionLinks;

export enum FooterButton {
    DEFAULT_DISCARD_CHANGES = "Discard changes",
    DEFAULT_SAVE_CHANGES = "Save Changes",
}

export enum FooterModalData {
    LEAVE_PAGE = "Leave Page",
    STAY_ON_PAGE = "Stay on page",
    UNSAVED_CHANGES = "Unsaved Changes",
    DISCARD_CHANGES_CONTENT = "Do you want to leave and discard these changes, or stay on this page?",
    SMARTBIZ_BY_AMAZON = "Smartbiz by Amazon"
}

declare global {
  interface Window {
    zE: any;
  }
}

export const handleEnableChat = (): void => {
  if (document.getElementById("ze-snippet")) {
    window?.zE("messenger", "open");
  }
};

export const footerConstants = [
  {
    id: 1,
    title: "Terms of Use",
    link: TERMS_OF_USE_LINK
  },
  {
    id: 2,
    title: "Privacy Policy",
    link: PRIVACY_POLICY_LINK
  },
  {
    id: 3,
    title: "Get Support",
    onClick: handleEnableChat
  },
];
